import React from "react";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import Button from "ComponentsUI/Button";
import ProviderConnectWithPhoneHOC from "HOC/ProviderConnectWithPhoneHOC";
import { sendMetriks } from "Services/sendMetriks";

function BrandButton(props) {
	let { mode, btn_text, btn_link, btn_bg_color, btn_text_color } = props.brand_button;

	let style = {
		backgroundColor: `${btn_bg_color}`,
		color: `${btn_text_color}`,
	};

	if (mode === "disabled" || !mode) return null;

	const clickHandler = () => {
		if (mode === "adviser") {
			Cookies.set("connectTariffFrom", "kartochka_brenda");
		}

		if (props.click === "prov1") {
			sendMetriks("CLICK_CONNECT_PROV1");
		}

		if (props.click === "prov2") {
			sendMetriks("CLICK_CONNECT_PROV2");
		}
	};

	return (
		<>
			{mode === "link" && (
				<a href={btn_link} target="_blank" onClick={() => clickHandler()} rel="noreferrer">
					<Button
						style={style}
						marginLeft={true}
						size="big"
						typeBrandButton={props.typeBrandButton}
						typeText="verybig"
					>
						{btn_text}
					</Button>
				</a>
			)}
			{mode === "adviser" && (
				<div onClick={() => clickHandler()}>
					<ProviderConnectWithPhoneHOC providerId={props.providerId}>
						<Button
							style={style}
							marginLeft={true}
							size="big"
							typeBrandButton={props.typeBrandButton}
							typeText="verybig"
						>
							{btn_text}
						</Button>
					</ProviderConnectWithPhoneHOC>
				</div>
			)}
		</>
	);
}

BrandButton.propTypes = {
	mode: PropTypes.string,
	providerId: PropTypes.number,
};

export default BrandButton;
